export default class PurchaseItem {
  id: string = "";
  estimateItemId: string = "";
  unitName: string = "";
  unitType: string = "";
  unitPrice: number = 0;
  amount: number = 0;
  totalPrice: number = 0;
  unitLoss: number = 0;
  loss: number = 0;
  memo: string = "";
  invalid: boolean = false;
  items: PurchaseItem[] = [];
}
